import mod from "-!../../_vue-loader@15.7.0@vue-loader/lib/index.js??vue-loader-options!./Monaco.vue?vue&type=script&lang=js&"; export default mod; export * from "-!../../_vue-loader@15.7.0@vue-loader/lib/index.js??vue-loader-options!./Monaco.vue?vue&type=script&lang=js&"


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-monaco-editor@0.0.19@vue-monaco-editor/src/Monaco.vue?vue&type=script&lang=js&
// module id = ./node_modules/_vue-monaco-editor@0.0.19@vue-monaco-editor/src/Monaco.vue?vue&type=script&lang=js&
// module chunks = 1